import { useNavigate } from 'react-router-dom';

const services = ['Interior Painting', 'Exterior Painting', 'Roof Painting', 'Fine Finish Spraying', 'Plastering & Gib Stopping', 'House Washing'];
const pages = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'Projects', href: '/projects' },
  { label: 'Community', href: '/community' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#1C2B3A] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-5">
              <img
                src="https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/c84baff364ecb2a1782d953744be14df.png"
                alt="ALFA Decorators Logo"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-white/55 text-sm leading-relaxed mb-6">
              Premium painting and decorating services across Wellington and the Hutt Valley. Clean, reliable, and built to last.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-facebook-line', href: 'https://www.facebook.com/profile.php?id=61568523262528' },
                { icon: 'ri-instagram-line', href: 'https://www.instagram.com/alfa.decorators/' },
                { icon: 'ri-linkedin-line', href: '#' },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-lg text-white/55 hover:bg-[#2D2D2D] hover:border-[#2D2D2D] hover:text-white transition-all cursor-pointer"
                >
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h5 className="font-bold text-white mb-5 text-sm uppercase tracking-wider">Services</h5>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s}>
                  <a
                    href="/services"
                    onClick={(e) => { e.preventDefault(); navigate('/services'); }}
                    className="text-white/55 text-sm hover:text-white transition-colors cursor-pointer"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Pages */}
          <div>
            <h5 className="font-bold text-white mb-5 text-sm uppercase tracking-wider">Company</h5>
            <ul className="space-y-2.5">
              {pages.map((p) => (
                <li key={p.href}>
                  <a
                    href={p.href}
                    onClick={(e) => { e.preventDefault(); navigate(p.href); }}
                    className="text-white/55 text-sm hover:text-white transition-colors cursor-pointer"
                  >
                    {p.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h5 className="font-bold text-white mb-5 text-sm uppercase tracking-wider">Contact</h5>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line text-gray-400 text-sm mt-0.5 flex-shrink-0" />
                <span className="text-white/55 text-sm">Wellington & Hutt Valley, New Zealand</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-phone-line text-gray-400 text-sm flex-shrink-0" />
                <a href="tel:0223760868" className="text-white/55 text-sm hover:text-white transition-colors">022-376-0868</a>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-gray-400 text-sm flex-shrink-0" />
                <a href="mailto:alfadecorators0@gmail.com" className="text-white/55 text-sm hover:text-white transition-colors">alfadecorators0@gmail.com</a>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-time-line text-gray-400 text-sm flex-shrink-0" />
                <span className="text-white/55 text-sm">Mon–Fri: 7am–6pm | Sat: 8am–4pm</span>
              </li>
            </ul>
            <a
              href="/contact"
              onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-[#2D2D2D] text-white text-sm font-semibold rounded-full whitespace-nowrap hover:bg-[#1a1a1a] transition-colors cursor-pointer"
            >
              Get a Free Quote <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/35 text-sm">
            &copy; 2025 ALFA Decorators. All rights reserved. Wellington & Hutt Valley painters.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" rel="nofollow" className="text-white/35 text-sm hover:text-white/60 transition-colors">Privacy Policy</a>
            <span className="text-white/20">|</span>
            <a href="#" rel="nofollow" className="text-white/35 text-sm hover:text-white/60 transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
